import { HttpErrorResponse } from '@angular/common/http';

/** C31: what the hopper does after a failed hop (V234). */
export type HopFailure = 'unlinked' | 'signed-out' | 'retry';

/**
 * 404 = the business was unlinked meanwhile; 401 = the session is gone.
 * Everything else (offline, 5xx, the NSM write gate's 403) leaves A open
 * and can be tried again.
 */
export function hopFailure(error: unknown): HopFailure {
  const status = error instanceof HttpErrorResponse ? error.status : null;
  if (status === 404) return 'unlinked';
  if (status === 401) return 'signed-out';
  return 'retry';
}
